import { Image, Pressable, StyleSheet, Text, View } from 'react-native';
import colors from '../theme';
import { ChildProfile } from '../api/profiles';
import { avatarSource } from '../utils/avatars';

type ChildProfileBadgeProps = {
  profile: ChildProfile | null;
  subtitle?: string;
  onLogout?: () => void;
  compact?: boolean;
};

export default function ChildProfileBadge({ profile, subtitle = 'Đã đăng nhập', onLogout, compact }: ChildProfileBadgeProps) {
  if (!profile) {
    return null;
  }

  return (
    <View style={[styles.card, compact && styles.compactCard]}>
      <View style={[styles.avatar, compact && styles.compactAvatar]}>
        <Image source={avatarSource(profile?.avatar_url)} style={[styles.avatarImage, compact && styles.compactAvatarImage]} resizeMode="contain" />
      </View>
      <View style={styles.info}>
        <Text style={[styles.name, compact && styles.compactName]} numberOfLines={1}>
          {profile.nickname}
        </Text>
        <Text style={styles.subtitle} numberOfLines={1}>{subtitle}</Text>
      </View>
      {onLogout ? (
        <Pressable style={styles.logoutButton} onPress={onLogout}>
          <Text style={styles.logoutText}>Thoát</Text>
        </Pressable>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 14,
    backgroundColor: colors.panel,
    borderRadius: 24,
    padding: 16,
  },
  compactCard: {
    borderRadius: 14,
    padding: 12,
    gap: 12,
  },
  avatar: {
    width: 56,
    height: 56,
    borderRadius: 20,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.tertiary,
  },
  compactAvatar: {
    width: 48,
    height: 48,
    borderRadius: 18,
  },
  avatarImage: {
    width: 42,
    height: 42,
  },
  compactAvatarImage: {
    width: 36,
    height: 36,
  },
  info: {
    flex: 1,
    minWidth: 0,
  },
  name: {
    color: colors.textPrimary,
    fontSize: 16,
    fontWeight: '900',
    marginBottom: 4,
  },
  compactName: {
    fontSize: 15,
  },
  subtitle: {
    color: colors.textSecondary,
    fontSize: 12,
    fontWeight: '700',
  },
  logoutButton: {
    minWidth: 72,
    height: 38,
    borderRadius: 14,
    backgroundColor: colors.accentSoft,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 12,
  },
  logoutText: {
    color: colors.button,
    fontSize: 13,
    fontWeight: '900',
  },
});
